export const dietKitchenRouteDef = [
    {
        path: ':resource/:orderId/:resource/button',
        component: 'DietKitchenComponent',
        data: {
            selector: 'kx-diet-kitchen'
        }
    },
    {
        path: ':resource/:orderId/:resource/set',
        component: 'DietKitchenComponent',
        data: {
            selector: 'kx-diet-kitchen'
        }
    },
    {
        path: ':resource/:id/:resource/update',
        component: 'DietKitchenComponent',
        data: {
            selector: 'kx-diet-kitchen'
        }
    },
    {
        path: ':resource/:orderId/:resource/diet_update',
        component: 'DietKitchenComponent',
        data: {
            selector: 'kx-diet-kitchen'
        }
    },
    {
        path: 'diet_ward_summary/summary',
        component: 'DynamicDataGridComponent',
        data: {
            selector: 'app-dynamic-data-grid',
            action: 'LIST',
            "resource": "nutrition_order"
        }
    },
    {
        path: 'diet-meal-item-update',
        component: 'DietMealItemComponent',
        data: {
            selector: 'app-diet-meal-item',
            action: 'LIST'
        }
    },
] 